export const SITE_URL = 'https://www.feedbask.com'

export function toAbsoluteUrl(pathname: string) {
	const base = SITE_URL.replace(/\/+$/, '')
	const path = pathname.startsWith('/') ? pathname : `/${pathname}`
	return `${base}${path}`
}

export function canonicalizePath(pathname: string) {
	if (!pathname) return '/'
	const withoutHash = pathname.split('#')[0] ?? pathname
	const withoutQuery = withoutHash.split('?')[0] ?? withoutHash
	const normalized = withoutQuery.startsWith('/') ? withoutQuery : `/${withoutQuery}`
	if (normalized !== '/' && normalized.endsWith('/')) {
		return normalized.replace(/\/+$/, '')
	}
	return normalized
}
